import '@mdi/font/css/materialdesignicons.min.css';
import moment from 'moment';
import components from './components/index';
import { clickoutside, tooltipDirective } from './directives';
import EntityManagerMixin from './mixins/EntityManagerMixin';
import FormatMixin from './mixins/FormatMixin';
import { notifications } from './store/notifications.module';
import { User } from './store/user.module';
import ApiClient from './utils/ApiClient';
import AuthManager from './utils/AuthManager';
import './veeValidate';

require('moment/locale/es');

const Cwstore = {
  notifications,
  User,
};

const CwAuthManager = AuthManager;

const CwCoreComponents = {
  install(Vue) {
    Vue.use(require('vue-moment'), {
      moment,
    });
    Vue.use(clickoutside);
    Vue.use(tooltipDirective);
    Vue.mixin(EntityManagerMixin);
    Vue.mixin(FormatMixin);
    Object.keys(components).forEach((component) => {
      Vue.component(components[component].name, components[component]);
    });
    Vue.prototype.$API = ApiClient;
  },
};

export default CwCoreComponents;

export { CwAuthManager, CwCoreComponents, Cwstore };
